define('home/templates/channelSuggestion',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.channelAvatarWithDefault,depth0,{"name":"channelAvatarWithDefault","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<img class=\"forum-favicon\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.favicon : depth0), depth0))
    + "\" alt=\""
    + ((stack1 = container.invokePartial(partials.forumName,depth0,{"name":"forumName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\">\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"recommended__item\">\n<a href=\"/home/channel/"
    + alias2(alias1((depth0 != null ? depth0.slug : depth0), depth0))
    + "/\"\nclass=\"avatar\"\ndata-link-name=\"channel_avatar\"\ndata-channel-slug=\""
    + alias2(alias1((depth0 != null ? depth0.slug : depth0), depth0))
    + "\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.channel : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</a>\n<h3 class=\"recommended__name truncate-line\">\n<a href=\"/home/channel/"
    + alias2(alias1((depth0 != null ? depth0.slug : depth0), depth0))
    + "/\"\ndata-link-name=\"channel_name\"\ndata-channel-slug=\""
    + alias2(alias1((depth0 != null ? depth0.slug : depth0), depth0))
    + "\">\n\n"
    + ((stack1 = container.invokePartial(partials.forumName,depth0,{"name":"forumName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</a>\n</h3>\n"
    + ((stack1 = container.invokePartial(partials.genericFollowButton,(depth0 != null ? depth0.primaryForum : depth0),{"name":"genericFollowButton","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n<div class=\"recommended__reason\"><em>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.description : stack1), depth0))
    + "</em></div>\n";
},"usePartial":true,"useData":true})

});
